/**
 * Merge catalog component values with per-product rows from custom_component_values.
 * Per-product entries override by value id; values only in the per-product list are appended
 * (e.g. product-specific custom_* options).
 */
export function mergeComponentValues(catalogValues, customList) {
  const catalog = catalogValues || [];
  if (!customList?.length) return [...catalog];
  const customById = new Map(customList.map((v) => [v.id, v]));
  const merged = catalog.map((v) => {
    const c = customById.get(v.id);
    return c ? { ...v, ...c } : v;
  });
  const catalogIds = new Set(catalog.map((v) => v.id));
  for (const cv of customList) {
    if (!catalogIds.has(cv.id)) {
      merged.push(cv);
    }
  }
  return merged;
}

export function mergeComponentType(baseType, customList) {
  if (!baseType) return null;
  return {
    ...baseType,
    values: mergeComponentValues(baseType.values, customList),
  };
}
